// extracted by mini-css-extract-plugin
module.exports = {"image":"hero_image__9fUn8"};